import { ReactComponent as Completed } from "assets/ProgressPillIcons/Completed.svg";
import { ReactComponent as InProgress } from "assets/ProgressPillIcons/InProgress.svg";
import { ReactComponent as New } from "assets/ProgressPillIcons/New.svg";
import { ReactComponent as Overdue } from "assets/ProgressPillIcons/Overdue.svg";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import {
  fetchOnboardingQueries,
  setShowOnboardingWizardFromLibrary
} from "components/features/Onboarding/Onboarding.slice";
import { Hall } from "components/features/library/libraryHall/Hall";
import { uniq, uniqBy } from "lodash";
import moment from "moment";
import { useEffect } from "react";
import { store } from "redux/store";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { axiosFileDownload, axiosPostFileDownload } from "./APIHelper";
import {
  ABOVE_PROPERTY_DISPLAY_TYPE,
  ABOVE_PROP_USER_TYPE,
  ON_PROPERTY_DISPLAY_TYPE,
  SME_PAGE_SIZE,
  brandDeadLine,
  corpUser,
  initiative,
  planSourceList,
  planTypes,
  sourceList,
  threshold
} from "./CommonConstants";

import {
  clearFilters,
  setDefaultFilterModified,
  updateCorpSavedFilters
} from "components/common/Filters/Filters.slice";
import {
  fetchSCListById,
  setCorpLoader,
  setCorpViewSelectedTab,
  setEditListSuccess,
  setIsEditListModal,
  setNavigatedMyList,
  setSelectedList,
  setSelectedListCategory
} from "components/features/Corp/CorpUser.Slice";
import { getUserDetails } from "components/features/SME/sme.slice";
import _ from "lodash";
import { responseTypes, tableExpandedValues } from "./Types";
import { LOGOUT_LOGIN_URL, ON_BOARDING } from "./URLConstants";

export const getHltInncodes = (isStringFormat = false) => {
  const { isImpersonated, userDetails }: any = store.getState().app.impersonationDetails;

  if (isImpersonated) {
    const inncodes = userDetails.innCodes;
    return isStringFormat ? inncodes.join(",") : inncodes || [];
  }

  const inncodes = localStorage.getItem("hltInnCodes");
  return isStringFormat ? inncodes : inncodes?.split(",") ?? [];
};

export const isBookmarked = (planId: any, innCodeToCompare?: string) => {
  const state: any = store.getState();
  const innCode = innCodeToCompare || state.app.innCode;
  const bookmarkedPlanList: any = state.bookmarkedPlans.list;
  const innCodeBookmark: any = bookmarkedPlanList.find((item: any) => item.innCode === innCode);

  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  return planId && bookmarkPlanIds.includes(planId.toString());
};

export const getGlobalLevelFilterCount = (FilterCategories: any) => {
  let count: number = 0;
  if (FilterCategories?.key === "planSource") {
    sourceList?.map((item: any) => {
      if (FilterCategories?.options?.includes(item.value[0])) count++;
    });
  } else count = FilterCategories?.options?.length;
  return count;
};

export const getUserTypeValue = (isIncludeAboveProperty: boolean) => {
  return isIncludeAboveProperty ? "" : "HU";
};

export const setSelectedMyList = (dispatch: any, list: any, filterType: string) => {
  dispatch(setNavigatedMyList(list));
  dispatch(setSelectedListCategory(filterType));
};

export const isAboveUserPlanBookmarked = (planId: any, planType: string) => {
  const state: any = store.getState();
  const bookmarkedPlanList: any = state.aboveProperty[planType];
  const attribute = planType === "bookmarkedIdList" ? "cmsId" : "templatePlanId";
  return bookmarkedPlanList?.find((item: any) => item[attribute] === planId);
};

export const formFilterRequestPayload = (appliedFilter: any[]) => {
  let requestObj: any = {};
  appliedFilter.forEach((item, index) => {
    requestObj[item?.key] = item?.options;
  });
  return requestObj;
};

export const getUserName = (getInitials = false, isCommentsPage = false) => {
  const { isImpersonated, userDetails }: any = store.getState().app.impersonationDetails;

  let firstName = localStorage.getItem("firstName")?.toString();
  let lastName = localStorage.getItem("lastName")?.toString();

  if (isImpersonated && !isCommentsPage) {
    firstName = userDetails.firstName;
    lastName = userDetails.lastName;
  }

  if (getInitials) return { firstName, lastName };

  if (isImpersonated) return userDetails.displayName || `${firstName || ""} ${lastName || ""}`;
  return `${firstName || ""} ${lastName || ""}`;
};

export const functionalAreaIdToName = (id: string, functionalAreaList: Hall[], showAbbrv = false) => {
  const functionalAreaName = functionalAreaList?.find((el: any) => el.id === id);
  return showAbbrv ? functionalAreaName?.abbrv : functionalAreaName?.name;
};

export const functionalAreaNamesToIds = (functionalAreaNames: any) => {
  const state: any = store.getState();
  return functionalAreaNames.map(
    (item: any) =>
      state.functionalAreas.list.find((area: any) => {
        return item === area.name;
      }).id
  );
};

export const functionalAreaIdsToNames = (functionalAreaIds: any) => {
  const state: any = store.getState();
  return functionalAreaIds?.map(
    (item: any) =>
      state.functionalAreas.list.find((element: any) => {
        return item === element.id;
      })?.name
  );
};

export const sourceValuetoName = (sourceValue: any) => {
  return uniq(sourceValue?.map((item: any) => getSourceName(item))) as string[];
};

export const planTypeIdToName = (planTypeIds: any) => {
  return planTypeIds.map(
    (id: any) =>
      planTypes.find((type: any) => {
        return id === type.planTypeId;
      })?.planTypeName
  );
};

export const filterPayloadToPlanProgressPayload = (filterPayload: any) => {
  return {
    planSources: filterPayload["planSource"]?.join(","),
    status: filterPayload["planStatus"]?.join(","),
    roleCategory: filterPayload["roleCategory"]?.join(","),
    searchedHltId: filterPayload["planOwner"]?.join(",")
  };
};

export const brandNameToBrandCode = (brandNames: any) => {
  const state: any = store.getState();
  return brandNames.map(
    (item: any) =>
      state.myplans.MyPlans.brands.find((brand: any) => {
        return item === brand.brandName;
      }).brandCode
  );
};

export const brandCodesToBrandNames = (brandIds: any) => {
  const state: any = store.getState();
  return brandIds.map(
    (item: any) =>
      state.myplans.MyPlans.brands.find((brand: any) => {
        return item === brand.brandCode;
      })?.brandName
  );
};

export const adminInncodeNameToId = (inncodeNames: any, selectedArr: any) => {
  const state: any = store.getState();
  const { adminInncodes } = state.myplans.MyPlans;
  const bookMarkInncodes = state.Dashboard.bookMarkInncodes;
  const inncodes = [...adminInncodes, ...bookMarkInncodes, ...selectedArr];
  return inncodeNames.map((item: any) => inncodes.find((innCode: any) => item === innCode?.innCode)?.innCode);
};

export const getPlanDuration = (sections: any) => {
  let sumDurationPlan = 0;
  if (sections?.length > 0) {
    for (let section of sections) {
      sumDurationPlan = sumDurationPlan + getSectionDuration(section?.cards);
    }
  }
  const result = getHoursAndMin(sumDurationPlan);
  return result;
};

export const getSectionDuration = (Cards: any) => {
  let sumDurationSection = Cards?.reduce((initial: any, current: any) => {
    return initial + current?.timeEstimateMinutes;
  }, 0);
  return sumDurationSection || 0;
};

export const getHoursAndMin = (Sum: any) => {
  if (!Sum) return [0, 0];
  let sumHours = Math.floor(Sum / 60);
  let sumMinutes = Sum % 60;
  return [sumHours, sumMinutes];
};

export const converter_ArrayString = (data: any, key = "val") => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el,
      [key]: el
    };
  });

  return dropArray;
};
export const converter_ArrayObj = (data: any, key: string) => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el.id,
      val: el[key]
    };
  });

  return dropArray;
};

export const converter_inncode_ArrayObj = (data: any, key: string) => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el.innCode,
      name: el[key]
    };
  });

  return dropArray;
};

export const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getInitials = (user: any) => {
  let firstChar;
  let secondChar;
  if (user?.firstName && user?.lastName) {
    firstChar = user?.firstName?.charAt(0).toUpperCase();
    secondChar = user?.lastName?.charAt(0).toUpperCase();
  } else if (user?.firstName) {
    firstChar = user?.firstName?.charAt(0).toUpperCase();
    secondChar = user?.firstName?.charAt(1).toUpperCase();
  } else if (user?.lastName) {
    firstChar = user?.lastName?.charAt(0).toUpperCase();
    secondChar = user?.lastName?.charAt(1).toUpperCase();
  } else if (user?.displayName) {
    firstChar = user?.displayName?.charAt(0).toUpperCase();
    secondChar = user?.displayName?.charAt(1).toUpperCase();
  } else {
    firstChar = user?.email?.charAt(0).toUpperCase();
    secondChar = user?.email?.charAt(1).toUpperCase();
  }
  return `${firstChar}${secondChar}`;
};

export const valueIsEmpty = (value: any) => {
  const type = typeof value;
  if ((value !== null && type === "object") || type === "function") {
    const props: any = Object.keys(value);
    if (props.length === 0 || props.size === 0) {
      return true;
    }
  }
  return !value;
};

export const userLogout = () => {
  console.log("Logging out due to idle timeout");
  localStorage.clear();
  window.location.replace(LOGOUT_LOGIN_URL);
};

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
  }, [...(deps || []), delay]);
};

export const encrypt = (salt: any, text: any) => {
  const textToChars = (text: any) => text.split("").map((c: any) => c.charCodeAt(0));
  const byteHex = (n: any) => Number(n).toString(16).substring(-2);
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code);

  return text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};

export const decrypt = (salt: any, encoded: any) => {
  const textToChars = (text: any) => text.split("").map((c: any) => c.charCodeAt(0));
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code);
  return encoded
    ?.match(/.{1,2}/g)
    .map((hex: any) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode: any) => String.fromCharCode(charCode))
    .join("");
};

export const createParamforSearch = (isAdmin: boolean, planInncode: string) => {
  if (isAdmin) return [planInncode];
  else return uniq([...(getHltInncodes() || []), planInncode]);
};

export const handleUnauthorizedAccess = (showDialog = false) => {
  if (showDialog) alert("You've been logged out!");
  localStorage.clear();
  localStorage.setItem("url", window.location.pathname + window.location.search);
  window.location.replace(LOGOUT_LOGIN_URL);
};

export const getFilteredAssignees = (assignee: any, allAssignees: any) => {
  return uniqBy(allAssignees, (element: any) => element.hltId).filter((currAssignee: any) =>
    assignee?.includes(currAssignee.hltId)
  );
};

export const onDownloadClick = (url: string, service: string, setNoAccess?: any) => {
  axiosFileDownload(url, service)
    .then((response: any) => {
      const filename = response.headers.get("content-disposition").split('"')[1];
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    })
    .catch((err) => {
      console.log(err, err);
      setNoAccess(true);
    });
};

export const onPostAPIDownloadFileHandler = async (url: string, service: string, data: any) => {
  store.dispatch(setCorpLoader(true));
  await axiosPostFileDownload(url, service, data)
    .then((response: any) => {
      const filename = response.headers.get("content-disposition").split('"')[1];
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    })
    .catch((err) => {
      console.log(err, err);
    });
  store.dispatch(setCorpLoader(false));
};

export const getUserTypeTag = (lobbyUserType: string) => {
  return String(lobbyUserType).toLowerCase() === ABOVE_PROP_USER_TYPE
    ? ABOVE_PROPERTY_DISPLAY_TYPE
    : ON_PROPERTY_DISPLAY_TYPE;
};

export const getIsCorpUser = (lobbyUserType: string) => {
  return corpUser.includes(String(lobbyUserType).toLowerCase());
};

export const getLoggedInUserDetails = () => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return isImpersonated ? userDetails : state.app.userName;
};

export const getLoggedInUserHltId = () => {
  return localStorage.getItem("hltId");
};

export const getUserHltId = () => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return isImpersonated ? userDetails.hltId : getLoggedInUserHltId();
};

export const matchOwnerWithHltId = (ownerList: string) => {
  const hltId = getUserHltId();
  if (hltId && ownerList.indexOf(hltId) > -1) return true;
  return false;
};

export const getOwnersList = () => {
  const state: any = store.getState();
  return (
    state.myPlanDetails.owner.length &&
    state.myPlanDetails?.owner
      ?.filter((item: any) => item?.displayName)
      .map((item: any) => item?.displayName)
      .join(", ")
  );
};
export const matchPlanType = (planType?: string, PlanDetail?: string) => {
  if (planType && (planType === brandDeadLine || initiative)) {
    return true;
  } else {
    return false;
  }
};
export const getPlantypeName = (planType?: number) => {
  if (planType === 1) {
    return brandDeadLine;
  } else if (planType === 2) {
    return initiative;
  } else {
    return null;
  }
};
export const getThresholdDetails = (value: string) => {
  switch (value) {
    case threshold.Outstanding: {
      return { backGroundColor: colors.Green.Green50, color: tokens.Text.Feedback.Done, label: value };
    }
    case threshold.Acceptable: {
      return {
        backGroundColor: tokens.Background.General.Secondary,
        color: tokens.Text.General.Secondary,
        label: value
      };
    }
    case threshold.Unacceptable: {
      return { backGroundColor: colors.Red.Red50, color: tokens.Text.Feedback.Alert, label: value };
    }
    default: {
      return { backGroundColor: "transparent", color: tokens.Text.General.PrimaryHeadline, label: value };
    }
  }
};

export const getPlanDetail = (planId: any, list: any) => {
  const plan = list?.find((el: any) => el.cmsId == planId);
  return plan;
};

export const filterData = (criteria: any, data: any) => {
  return data.filter((obj: any) => {
    return Object.keys(criteria).every((key: any) => {
      return (
        (Array.isArray(criteria[key]) &&
          criteria[key].some((c: any) => {
            return typeof obj[key] === "string" && obj[key].indexOf(c) > -1;
          })) ||
        criteria[key].length === 0
      );
    });
  });
};
export const getChipDetails = (totalCards: 0, completedCards: 0, cardList?: []) => {
  const isOverdue = cardList?.some(
    (item: any) =>
      moment(item?.dueDate).isBefore(moment(new Date()).format("YYYY-MM-DD")) && item?.status !== "Completed"
  );

  let icon = <New />,
    color = tokens.Text.Feedback.Neutral,
    backgroundColor = tokens.Background.General.Tertiary;

  switch (true) {
    case isOverdue: {
      icon = <Overdue />;
      color = tokens.Text.Feedback.OverdueDark;
      backgroundColor = colors.Orange.Orange100;
      break;
    }
    case completedCards < totalCards && cardList?.some((item: any) => item?.status === "Completed"): {
      icon = <InProgress />;
      color = tokens.Text.Feedback.ProgressDark;
      backgroundColor = colors.Cyan.Cyan100;
      break;
    }
    case completedCards === totalCards && completedCards > 0: {
      icon = <Completed />;
      color = tokens.Text.Feedback.SuccessDark;
      backgroundColor = colors.Green.Green100;
      break;
    }
  }

  return {
    icon,
    color,
    backgroundColor,
    label: `${completedCards ?? 0}/${totalCards ?? 0} Actions Completed`
  };
};

export const getListOfFilters = () => {
  const state: any = store.getState();
  const {
    selectedFunctionalAreas,
    selectedInncodes,
    selectedBrand,
    selectedStatus,
    selectedPlanType,
    filterIds,
    selectedUser
  } = state.app;

  const selectedAdminInncodes = state.myplans.MyPlans.selectedAdminInncodes;

  const filtersArray = [
    selectedFunctionalAreas,
    selectedInncodes,
    selectedBrand,
    selectedStatus,
    selectedPlanType,
    filterIds,
    selectedAdminInncodes,
    selectedUser
  ];
  const filteredData = filtersArray?.filter((element) => element?.length > 0);

  return filteredData;
};

export const userNameToHltId = (userNames: any, state: any, hltKey?: string) => {
  return userNames.map(
    (item: any) =>
      state.find((op: any) => {
        return item === op.displayName;
      })[hltKey ?? "hltId"]
  );
};

export const getRoleCategory = (hltIds: string[]) => {
  const state: any = store.getState();
  let response = hltIds?.map(
    (ele: any) => state.aboveProperty?.roleCategoryList?.find((element: any) => element.hltId === ele)?.roleCategory
  );
  response = response?.filter((el: any) => el?.length);
  if (response?.length > 0) return response?.includes("Leadership") ? "Leadership" : "Non-Leadership";
  else return null;
};
export const getOwnerNames = (hltIds: string[]) => {
  const state: any = store.getState();
  const response = state.aboveProperty?.roleCategoryList?.filter((ele: any) => {
    return hltIds?.find((element: any) => ele.hltId === element);
  });
  const ownerNames = response?.map((el: any) => el?.displayName);
  return ownerNames;
};

export const getPropertyName = (inncode: string) => {
  const state: any = store.getState();
  return state.aboveProperty.propertyList.find((element: any) => element.innCode === inncode)?.propName;
};
export const getPropertyInncode = (propertyNames: string[]) => {
  const state: any = store.getState();
  const response = state.aboveProperty.propertyList.filter((element: any) => {
    return propertyNames?.find((ele: any) => ele === element.propName);
  });
  const propertyInncodes = response?.map((el: any) => el?.innCode);

  return propertyInncodes;
};
export const getPropertyNames = (inncodes: string[]) => {
  const propertyNames = inncodes?.map((el: any) => getPropertyName(el));
  return propertyNames;
};

export const getMoreValues = (list: any) => {
  if (!list?.length) return "-";
  return list?.length > 1 ? `${list[0]}, (+${list.length - 1})` : `${list[0]}`;
};

export const getSourceName = (source: string) => {
  return source in planSourceList ? planSourceList[source] : "-";
};

export const getKeyByValue = (object: any, value: any) => {
  return Object.keys(object).filter((key) => object[key] === value);
};

export const getPlanSourceId = (sources: string[]) => {
  return sources.map((s: any) => Object.keys(planSourceList).filter((k: any) => planSourceList[k] === s));
};

export const getBrandCodesForAboveProperties = (brandNames = [], allProperties: any) => {
  return brandNames.map(
    (item: any) =>
      allProperties.find((a: any) => {
        return item === a.brandName;
      })?.brandCode
  );
};
export const checkUserAccess = (type: string) => {
  if (!type) return true;
  const state: any = store.getState();
  const isAdmin = state.app.isAdmin;
  const accessRoles = state.app.loggedInUserDetails.accessRoles;
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;

  if (isAdmin || isImpersonated) return accessRoles[type];
  else return true;
};

export const triggerOnboadingWizard = (dispatch: any) => {
  const state: any = store.getState();
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;
  const isOnboardingCompleted = state.onboardingResponse.isOnboardingCompleted;

  if (isImpersonated && !isOnboardingCompleted) {
    dispatch(
      setFeedbackDetails({
        shouldShow: true,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: `'${getUserName()}' has not taken the wizard yet.`
      })
    );
  } else {
    const onBoardingData: any = {
      wizardType: ON_BOARDING
    };
    dispatch(fetchOnboardingQueries(onBoardingData));
    dispatch(setShowOnboardingWizardFromLibrary(true));
  }
};

export const updateSavedFilter = async (dispatch: any, payload: any) => {
  await dispatch(updateCorpSavedFilters(payload));
  dispatch(setDefaultFilterModified({ isFilterChanged: false, isApplied: false }));
};

export const setInitialWizardTaken = () => {
  localStorage.setItem("isInitialOnboardingCompleted", "true");
};

export const getInitialWizardTaken = () => {
  return localStorage.getItem("isInitialOnboardingCompleted") === "true";
};

export const addDynamicId = (data: any) => {
  const newData = data.map((innCode: any, index: number) => {
    innCode.id = index;
    return innCode;
  });
  return newData;
};
export const getKeyMetricsPropertiesData = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Properties",
      data: overview?.totalPropertiesCount
    },
    { subTitle: "Active", data: overview?.activePropertiesCount, showBorder: true },
    {
      subTitle: "*Adding Plans",
      data: overview?.addingPlanPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Completing Plans",
      data: overview?.completingPlansPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "With Overdue Plans",
      data: overview?.withOverDuePlansPropertiesCount
    }
  ];
};

export const getKeyMetricsPropertiesDataForSc = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Properties",
      data: overview?.totalPropertiesCount
    },
    { subTitle: "*Plans Assigned", data: overview?.assignedCmsPlansCount, showBorder: true },
    {
      subTitle: "*High Engagement",
      data: overview?.highEngagementPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Medium Engagement",
      data: overview?.mediumEngagementPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Low Engagement",
      data: overview?.lowEngagementPropertiesCount
    }
  ];
};

export const getKeyMetricsPlansData = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "*Total Plans",
      data: overview.totalMyPlans
    },
    { subTitle: "Active", data: overview.activeMyPlans, showBorder: true },
    {
      subTitle: "New",
      data: overview.newMyPlans,
      showBorder: true
    },
    {
      subTitle: "Overdue",
      data: overview.overdueMyPlans,
      showBorder: true
    },
    {
      subTitle: "*Completed",
      data: overview.completedMyPlans
    }
  ];
};

export const getKeyMetricsPlansDataSC = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Inncodes",
      data: overview.totalPropertiesCount
    },
    { subTitle: "Plan Assignments", data: overview.planAssignmentsCount, showBorder: true },
    {
      subTitle: "Plan w/ overdues Actions",
      data: overview.plansWithOverdueCardsCount,
      showBorder: true
    },
    {
      subTitle: "Plan w/ unassigned Actions",
      data: overview.plansWithUnassignedCardsCount,
      showBorder: false
    }
  ];
};

export const getTableColor = (val: string) => {
  if (val) {
    const newVal = val.replace(/\s/g, "").toLowerCase();
    return tableExpandedValues[newVal];
  }
  return tokens.Text.General.PrimaryBody;
};

/* Filtered out the entries with a count not equal to zero
Converted the object into an array of key-value pairs to use in the common table*/
export const getplanSourceCount = (list: any) => {
  if (list) {
    let counts: { [key: string]: number } = {};
    let sourceListData = sourceList;
    for (const key in list) {
      if (key in list) {
        const count = list[key];
        for (const item of sourceListData) {
          if (item.value.includes(key)) {
            counts[item.name] = (counts[item.name] || 0) + count;
            break;
          }
        }
      }
    }

    const array_List = Object.entries(counts)
      .filter(([_, count]) => count > 0)
      .map(([name, value]) => ({ name, value }));
    return array_List;
  }
  return null;
};

export const bookmarkedHandleClick = (indexValue: number) => {
  const state: any = store.getState();
  const savedFiltersAndLists: any = state.filters.savedFilter;
  store.dispatch(clearFilters({ eliminateMyList: true }));
  store.dispatch(setSelectedListCategory("bookmarked"));
  store.dispatch(setSelectedList(savedFiltersAndLists["bookmarked"]?.[indexValue]));
  store.dispatch(setCorpViewSelectedTab({ type: "myList", val: indexValue }));
};

const extractHltIds = (dataArray: any) => {
  return dataArray.filter((item: any) => item.hasOwnProperty("hltId")).map((item: any) => item.hltId);
};

const transformData = (dataArray: any) => {
  return dataArray.reduce((acc: any, item: any) => {
    if (item.hltId) {
      acc[item.hltId] = item;
    }
    return acc;
  }, {});
};

const dataFormationForScUser = async (val: any) => {
  const response = await store.dispatch(
    fetchSCListById({
      id: val.id,
      view: "inncodes",
      engagement: "",
      innCode: "",
      size: SME_PAGE_SIZE
    })
  );
  const payload = response?.payload;
  if (payload?.status === responseTypes.success) {
    const responseData: any = payload?.data;
    const mappings = responseData.mappings;
    const hltIds = extractHltIds(mappings);
    const res = await store.dispatch(getUserDetails(hltIds));
    const userList = res?.payload ? transformData(res?.payload) : [];
    responseData.description = val.description;
    responseData.isFlagged = val.isFlagged;
    store.dispatch(setEditListSuccess({ userList, listData: responseData, type: "sc" }));
    store.dispatch(setIsEditListModal(true));
  }
};

export const editList = async (val: any, type: string) => {
  if (type === "sc") {
    dataFormationForScUser(val);
  } else {
    store.dispatch(setEditListSuccess({ userList: null, listData: val, type: "static" }));
    store.dispatch(setIsEditListModal(true));
  }
};
export const getNamesFromHtlId = (hltIds: string[], dataList: any) => {
  const response = dataList?.filter((ele: any) => {
    return hltIds?.find((element: any) => ele.hltId === element);
  });
  const names = response?.map((el: any) => el?.displayName);
  return names;
};

export const setExtractMemberList = (memberList: any) => {
  let member: string[] = [];
  if (memberList && memberList.length) {
    memberList.map((user: any) => {
      if (user.inncodeusers) {
        member = [...user.inncodeusers, ...member];
      }
    });
  }
  return _.uniq(member);
};

export const getUserNameByHltId = (allUsers: any, userInfo: any) => {
  const user = allUsers.find((user: any) => user.hltId === userInfo);
  return user;
};

export const getAllMapedIdAndUsers = (mappings: any) => {
  const mappingId: number[] = [];
  const hltId: string[] = [];
  mappings.map((mapped: any) => {
    mappingId.push(mapped.mappingId);
    hltId.push(mapped.hltId);
  });
  return { mappingId, hltId };
};
